import { BannerProps } from 'shared/components/Context/UserContext'

import { fieldToTitleCase } from './helpers/utils'

interface FormError {
  errors: {
    attr: string
    code: string
    detail: string
  }[]
  type: string
}

function formatAttr(attr: string): string {
  return attr.split('.').map(fieldToTitleCase).join(' ')
}

export function formatErrorsForBanner(error: FormError): BannerProps {
  return {
    title: 'Error',
    message: error.errors.map((err) => `${formatAttr(err.attr)}: ${err.detail}`),
  }
}
